import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { stringify } from 'query-string';
import { Grid, Link, Typography } from '@material-ui/core';

// CONSTANTS
import { ROUTE_DISCOVER_SEARCH } from '@/constants/routes';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { Container } from './styles';

function getGenreLink(name) {
  if (!name) {
    return ROUTE_DISCOVER_SEARCH;
  }

  const qsParams = { genres: [name.toLowerCase()], page: 1, type: ['free', 'paid'] };
  const search = stringify(qsParams, {
    arrayFormat: 'comma',
    skipEmptyString: true,
  });

  return search ? `${ROUTE_DISCOVER_SEARCH}?${search}` : ROUTE_DISCOVER_SEARCH;
}

const Genres = ({ data, className }) => {
  const [t] = useTranslation();

  if (!data.length) return null;

  return (
    <Container className={clsx('genres', className)}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <Typography className="p4" component="span" color="textSecondary">
            {t(`common.${data.length > 1 ? 'genresLabel' : 'genreLabel'}`)}:
          </Typography>
        </Grid>

        {data.map((genre, index) => {
          if (!(genre.genre_name || genre.genre_slug)) return null;

          const disabled = genre.genre_type_id_fk === 6;

          let chipProps = {
            component: 'span',
          };

          if (!disabled) {
            chipProps = {
              to: getGenreLink(genre.genre_slug),
              component: RouterLink,
              target: '_blank',
            };
          }

          return (
            <Grid item key={index}>
              <Link {...chipProps} color="textPrimary">
                {genre.genre_name}
              </Link>
              {data.length !== index + 1 && <>&#44;</>}
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

Genres.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default React.memo(Genres);
